import { ChangeDetectionStrategy, Component } from "@angular/core";
import { TableColumn } from "src/app/slots/three-year-plan/common/components/table/classes/table-column";

@Component({
  selector: "app-municipality-info-column",
  templateUrl: "./municipality-info-column.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MunicipalityInfoColumnComponent extends TableColumn {}
